module.exports = __webpack_public_path__ + "img/1-25.16484490.jpg";